// `value` matches what's stored in the DB (students.grade_level, subjects.grade_level) —
// a bare grade number, not the "Grade N" display text. The public /student-record page
// prepends "Grade " itself, so the stored value must stay a bare number.
export const GRADE_LEVELS = [
  { value: '7', label: 'Grade 7' },
  { value: '8', label: 'Grade 8' },
  { value: '9', label: 'Grade 9' },
  { value: '10', label: 'Grade 10' },
  { value: '11', label: 'Grade 11' },
  { value: '12', label: 'Grade 12' },
];

export function getGradeLevelLabel(value) {
  return GRADE_LEVELS.find((g) => g.value === String(value))?.label ?? value;
}
